export default "__VITE_ASSET__jFbMkrLC__"